var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3289 17.2346C18.1689 17.2346 18.0189 17.1846 17.8789 17.0846C17.5489 16.8346 17.4789 16.3646 17.7289 16.0346C19.2989 13.9446 19.2989 11.0246 17.7289 8.93465C17.4789 8.60465 17.5489 8.13465 17.8789 7.88465C18.2089 7.63465 18.6789 7.70465 18.9289 8.03465C20.8889 10.6546 20.8889 14.3146 18.9289 16.9346C18.7789 17.1346 18.5589 17.2346 18.3289 17.2346Z",
    fill: "url(#paint0_linear_3780_18298)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1589 19.7346C19.9989 19.7346 19.8489 19.6846 19.7089 19.5846C19.3789 19.3346 19.3089 18.8646 19.5589 18.5346C22.2289 14.9746 22.2289 9.99465 19.5589 6.43465C19.3089 6.10465 19.3789 5.63465 19.7089 5.38465C20.0389 5.13465 20.5089 5.20465 20.7589 5.53465C23.8289 9.62465 23.8289 15.3446 20.7589 19.4346C20.6189 19.6346 20.3889 19.7346 20.1589 19.7346Z",
    fill: "url(#paint1_linear_3780_18298)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3489 4.26605C13.2289 3.64605 11.7989 3.80605 10.3389 4.71605L7.41892 6.54605C7.21892 6.66605 6.98892 6.73605 6.75892 6.73605H5.82892H5.32892C2.90892 6.73605 1.57892 8.06605 1.57892 10.4861V14.4861C1.57892 16.9061 2.90892 18.2361 5.32892 18.2361H5.82892H6.75892C6.98892 18.2361 7.21892 18.3061 7.41892 18.4261L10.3389 20.2561C11.2189 20.8061 12.0789 21.0761 12.8789 21.0761C13.3989 21.0761 13.8989 20.9561 14.3489 20.7061C15.4589 20.0861 16.0789 18.7961 16.0789 17.0761V7.89605C16.0789 6.17605 15.4589 4.88605 14.3489 4.26605Z",
    fill: "url(#paint2_linear_3780_18298)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3780_18298",
    x1: 18.9888,
    y1: 7.73437,
    x2: 18.9888,
    y2: 17.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3780_18298",
    x1: 21.235,
    y1: 5.23437,
    x2: 21.235,
    y2: 19.7346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3780_18298",
    x1: 8.82892,
    y1: 3.89453,
    x2: 8.82892,
    y2: 21.0761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.31195dd8dd2d3039c7b3e05f0c136e1d.svg";
export { ForwardRef as ReactComponent };